import Resources1 from "../assets/resources-1.png";
import Resources2 from "../assets/resources-2.png";
import Resources3 from "../assets/resources-3.png";

export const title =
  "text-center text-black sm:text-4xl text-3xl font-catamaran font-extrabold ";

export const whiteTitle =
  "text-center text-white sm:text-4xl text-3xl font-catamaran font-extrabold ";

export const textStartTitle =
  "text-start text-black sm:text-4xl text-3xl font-catamaran font-extrabold ";

export const paragraph =
  "sm:text-base text-sm text-black font-roboto lg:leading-8 leading-6 text-center";

export const whiteParagraph =
  "sm:text-base text-sm text-[#DDF3F7] font-roboto lg:leading-8 leading-6 text-center";

export const textStartParagraph =
  "sm:text-base text-sm text-black font-roboto lg:leading-8 leading-6 text-start";

export const button =
  "sm:p-4 p-3 border-[1px] border-black font-roboto font-normal tracking-wide rounded-md hover:bg-black hover:text-white";

export const resourcesData = [
  {
    image: Resources1,
    title: "17 Big Tax Deductions for Small Businesses (2022)",
    para: "Here's a list of small business tax deductions commonly available to entrepreneurs. Check it twice, and make sure you're claiming everything you can.",
  },
  {
    image: Resources2,
    title: "Top 12 Questions to Ask an Accountant",
    para: "Accountants aren’t just numbers people—they’re business advisors. Ask your accountant these questions when you want objective advice to grow your business.",
  },
  {
    image: Resources3,
    title: "10 Steps to Streamline Your Month End Close Process",
    para: "If the month-end close process feels like a mountain of tedious admin, you're not alone. Our closing checklist can help you scale the summit with ease.",
  },
];

export const footerData = [
  {
    title: "PRODUCT",
    details: ["How It Works", "Take A Tour", "Pricing", "Security"],
  },
  {
    title: "RESOURCES",
    details: ["Education", "Tools & Guides", "FAQ", "Customer Reviews"],
  },
  {
    title: "PARTNER",
    details: ["Refer A Friend", "Partner Marketplace", "Embedded Bookkeeping"],
  },
];

export const privacyPolicyData = [
  "Bench 2011 - 2022",
  "Terms of Services",
  "Privacy Policy",
  "Terms of Use",
  "Cookie Policy",
  "Security Practices",
];
